// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"7f89fb7e","990":"7a99414e"}[chunkId] + ".chunk.js";
};